<template>
  <!-- 专业交流 -->
  <div class="box">
    <details-head img="./img/bj3.png" title="专业交流" remarks="Professional exchanges" />
    <TopBreadcrumb :data="[{ label: '知识库' }, { label: '专业交流' }]" />
    <div class="con" v-loading="loading">
      <div class="title">专业交流</div>
      <div class="list">
        <div class="item" v-for="item,i in list" :key="i">
          <img :src="item.img" alt="">
          <div class="name">{{item.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DetailsHead from "../../components/DetailsHead.vue";
import TopBreadcrumb from "../../components/TopBreadcrumb.vue";
export default {
  components: { DetailsHead, TopBreadcrumb },
  data() {
    return {
      loading: false,

      list:[
        {
            img:'./img/NewsCenter/info-tab-item.png',
            name:'刘加平：中国建筑节能现状及未来发展趋势'
        },
        {
            img:'./img/NewsCenter/info-tab-item.png',
            name:'著名建筑师刘昊威专访'
        },
        {
            img:'./img/NewsCenter/info-tab-item.png',
            name:'广东“三师下乡”活动开展一周年硕果累累'
        },
        {
            img:'./img/NewsCenter/info-tab-item.png',
            name:'修龙院长与崔愷院士关于绿色建筑的对话'
        },
      ]
    };
  },
  mounted() {},
  methods: {},
};
</script>
 
<style lang="less" scoped>
.con {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 80px;
}
.title {
  padding: 15px 10px;
  font-size: 30px;
  font-weight: bold;
  color: #1d499e;
  border-bottom: 1px solid #eee;
  display: block;
}
.list {
  margin-top: 30px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  row-gap: 20px;
  column-gap: 20px;
  .item {
    cursor: pointer;
    img {
      width: 100%;
      aspect-ratio: 16 / 9;
    }
    .name {
        text-align: center;
        padding: 10px;
      font-size: 10px;
      color: #000;
    }
  }
}
</style>